import { error } from 'console';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as Highcharts from 'highcharts';
import { LoggerService } from './logger.service';
 // import {Chart} from 'angular-highcharts';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PageEvent } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-logger',
  templateUrl: './logger.component.html',
  styleUrls: ['./logger.component.css']
})
export class LoggerComponent implements OnInit {
  constructor(private snotifyService: ToastrService,private transactionsService :LoggerService, private modalService: BsModalService,){

  }
    modalRef: BsModalRef | undefined;
        modalRef2: BsModalRef | undefined;
  // allTransactions: Transaction[] = [
  //   { id: 'TXN-0041', collectorName: 'Alice Johnson',  paymentRefNumber: 'REF-8821', transactionDate: '12/03/24 — 09:14', paymentMethods: ['Visa'],            status: 'Successful' },
  //   { id: 'TXN-0042', collectorName: 'Bob Martinez',   paymentRefNumber: 'REF-4432', transactionDate: '12/03/24 — 10:05', paymentMethods: ['Cash'],            status: 'Partially Successful' },
  //   { id: 'TXN-0043', collectorName: 'Carol White',    paymentRefNumber: 'REF-9923', transactionDate: '12/03/24 — 10:52', paymentMethods: ['Cheque'],          status: 'Failed' },
  //   { id: 'TXN-0044', collectorName: 'Alice Johnson',  paymentRefNumber: 'REF-2210', transactionDate: '12/03/24 — 11:30', paymentMethods: ['Visa', 'Cash'],    status: 'Successful' },
  //   { id: 'TXN-0045', collectorName: 'Bob Martinez',   paymentRefNumber: 'REF-7701', transactionDate: '12/03/24 — 12:18', paymentMethods: ['Cheque', 'Cash'],  status: 'Successful' },
  //   { id: 'TXN-0046', collectorName: 'Carol White',    paymentRefNumber: 'REF-3390', transactionDate: '12/03/24 — 13:04', paymentMethods: ['Cheque', 'Visa'],  status: 'Successful' },
  //   { id: 'TXN-0047', collectorName: 'Alice Johnson',  paymentRefNumber: 'REF-5512', transactionDate: '12/03/24 — 13:45', paymentMethods: ['Cash'],            status: 'Successful' },
  //   { id: 'TXN-0048', collectorName: 'Bob Martinez',   paymentRefNumber: 'REF-1143', transactionDate: '12/03/24 — 14:22', paymentMethods: ['Cash'],            status: 'Failed' },
  //   { id: 'TXN-0049', collectorName: 'Carol White',    paymentRefNumber: 'REF-6634', transactionDate: '12/03/24 — 15:11', paymentMethods: ['Visa', 'Cash'],    status: 'Failed' },
  //   { id: 'TXN-0050', collectorName: 'Alice Johnson',  paymentRefNumber: 'REF-8870', transactionDate: '12/03/24 — 15:58', paymentMethods: ['Visa'],            status: 'Partially Successful' },
  //   { id: 'TXN-0051', collectorName: 'Bob Martinez',   paymentRefNumber: 'REF-2245', transactionDate: '12/03/24 — 16:30', paymentMethods: ['Cheque'],          status: 'Failed' },
  //   { id: 'TXN-0052', collectorName: 'Carol White',    paymentRefNumber: 'REF-9901', transactionDate: '12/03/24 — 17:02', paymentMethods: ['Cash'],            status: 'Pending' },
  //   { id: 'TXN-0053', collectorName: 'Alice Johnson',  paymentRefNumber: 'REF-4476', transactionDate: '12/03/24 — 17:49', paymentMethods: ['Visa'],            status: 'Successful' },
  //   { id: 'TXN-0054', collectorName: 'Bob Martinez',   paymentRefNumber: 'REF-7723', transactionDate: '12/03/24 — 18:15', paymentMethods: ['Cash', 'Cheque'],  status: 'Successful' },
  // ];

  // ── Dropdown options ─────────────────────────────────────────────────────────
  readonly collectorOptions: string[] = ['Alice Johnson', 'Bob Martinez', 'Carol White'];
  //readonly statusOptions: TransactionStatus[] = ['Successful', 'Partially Successful', 'Failed', 'Pending'];

  // ── Filter state ─────────────────────────────────────────────────────────────
  selectedCollector: any  ;
  selectedStatus: any =0 ;

  // ── Filtered view ────────────────────────────────────────────────────────────
  filteredTransactions: Transaction[] = [];

  // ── Pagination ───────────────────────────────────────────────────────────────

  currentPage: number = 1;
  pagedTransactions: Transaction[] = [];
  totalPages: number = 1;
  pages: number[] = [];

  // ────────────────────────────────────────────────────────────────────────────

  ngOnInit(): void {

  }
  searchKey:any
ngAfterViewInit(): void {
  //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
  //Add 'implements AfterViewInit' to the class.
   this.applyFilters();
}
  getStatusName(status: number): string {
  return this.statusMap[status]?.name ?? '';
}
  applyFilters(): void {

    this.GetAllLogger();
  }

  pageIndex = 0;
  pageSize = 10;
  length:any
    onPageChange(event: PageEvent): void {

       this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize

        this.GetAllLogger()





    }



  GetAllLogger(): void {

    let paylaod = {


   pageSize : this.pageSize,
   pageNumber : this.pageIndex,
   SearchValue:this.searchKey,
   status:this.selectedStatus == "" ? 0 :this.selectedStatus
    }
    this.transactionsService.GetAllLogger(paylaod).subscribe(res=>{
      this.pagedTransactions = res.data
      this.length = res.totalCount
    })
  }



  getInitials(name: string): string {
    return name.split(' ').map(w => w.charAt(0)).join('').toUpperCase();
  }

  // getStatusClass(status: TransactionStatus): string {
  //   const map: Record<TransactionStatus, string> = {
  //     'Successful':           'badge-success',
  //     'Partially Successful': 'badge-partial',
  //     'Failed':               'badge-failed',
  //     'Pending':              'badge-pending',
  //   };
  //   return map[status] ?? '';
  // }

getStatusClass(status: number): string {
  return this.statusMap[status]?.class ?? '';
}

setCurrent(index: number,versionObj) {
  this.versions.forEach((v, i) => {
    v.isCurrent = i === index;
  });

    this.transactionsService.SetMainVersion(this.loggerId,versionObj.id).subscribe(res=>{},error=>{
             this.snotifyService.error("", "Somthing was error !!!", {
            timeOut: 2500,
            progressBar: true,
            tapToDismiss: true
          });
    })
}

Resubmit(payload:any){
this.transactionsService.ReSubmitLog(payload.id).subscribe(res=>{
  if(res.success == false){
 this.snotifyService.error("", "Resubmission failed !!!", {
            timeOut: 2500,
            progressBar: true,
            tapToDismiss: true
          });

  }else{
  this.GetAllLogger()
  }

},error=>{


})
}
  statusMap: Record<number, { name: string; class: string }> = {
    //  0: { name: 'zero status',            class: 'badge-success' },

  1: { name: 'In Progress',            class: 'badge-inprogress' },
  2: { name: 'Success',  class: 'badge-success' },
  3: { name: 'Failed',                class: 'badge-failed' },
  4: { name: 'Retried',               class: 'badge-pending' },
  5: {   name: 'Cancelled',   class: 'badge-cancelled'  }
};

statusOptions = [
    { id: 0, name: 'Select Status', class: 'badge-inprogress' },

  { id: 1, name: 'In Progress', class: 'badge-inprogress' },
  { id: 2, name: 'Success',     class: 'badge-success'    },
  { id: 3, name: 'Failed',      class: 'badge-failed'     },
  { id: 4, name: 'Retried',     class: 'badge-retried'    },
  { id: 5, name: 'Cancelled',   class: 'badge-cancelled'  }
];
  get startRow(): number {
    return this.filteredTransactions.length === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1;
  }

  get endRow(): number {
    return Math.min(this.currentPage * this.pageSize, this.filteredTransactions.length);
  }

versions=[]
loggerId:any
CallGetVersionsByLoggerId(loggerId){
this.transactionsService.GetVersionsByLoggerId(loggerId).subscribe(res=>{
  this.versions = res.versions
})
}
   openFileDialog(template: TemplateRef<any>,loggerId:any) {
this.loggerId = loggerId
this.CallGetVersionsByLoggerId(loggerId)

    this.modalRef = this.modalService.show(template, {
      backdrop: 'static',
      keyboard: false,
      class: 'modal-dialog-centered modal-lg'
    });
  }
    RemovePopup(template: TemplateRef<any>) {

     this.modalRef?.hide();
}


  jsonData: string = `{
  "subject": {
    "math": {
      "q1": { "question": "8 + 2 = ?", "answer": "10" }
    }
  }
}`;

  jsonError: string = '';
  jsonValid: boolean = false;
versionPayload:any={}
 openModal(template: TemplateRef<any>,payload) {

this.versionPayload=payload

  try{  this.jsonData = payload.request }
  catch{  this.jsonData = JSON.parse("{error:'Invalid Request'}") }
    this.modalRef2 = this.modalService.show(template, {
      class: 'modal-lg'
    });
  }

  submitJson() {
    this.jsonError = '';
    this.jsonValid = false;

    try {
      const parsed = JSON.parse(this.jsonData);

      // optional: beautify JSON automatically
      this.jsonData = JSON.stringify(parsed, null, 2);

      this.jsonValid = true;

      console.log('Valid JSON:', parsed);
var x =this.jsonData
  let payload = {
  ecomLogId: this.loggerId,
  request:this.jsonData,
  header: this.versionPayload?.header,
  method: this.versionPayload?.method,
  URL: this.versionPayload?.url,
  response: this.versionPayload?.response,
  statusCode: this.versionPayload?.statusCode
};
this.transactionsService.AddLogVersion(payload).subscribe(res=>{
  this.CallGetVersionsByLoggerId(this.loggerId)
this.modalRef2?.hide()
},error=>{
       this.snotifyService.error("", "Somthing was error !!!", {
            timeOut: 2500,
            progressBar: true,
            tapToDismiss: true
          });
})
      // close modal if you want
      // this.modalRef?.hide();

    } catch (err: any) {
      this.jsonError = 'Invalid JSON format: ' + err.message;
    }
  }

  closeModal(){
    this.modalRef?.hide()
  }
}
export type PaymentMethod = 'Visa' | 'Cash' | 'Cheque';
// export type TransactionStatus = 'Successful' | 'Partially Successful' | 'Failed' | 'Pending';

export interface Transaction {
  id: string;
  collectorName: string;
  paymentRefNumber: string;
  transactionDate: string;
  paymentMethods: PaymentMethod[];
  status: TransactionStatus;
}

export enum TransactionStatus {
  Successful = 1,
  PartiallySuccessful = 2,
  Failed = 3,
  Pending = 4
}
